import { render, staticRenderFns } from "./OnlyOfficeEditor.vue?vue&type=template&id=1680bfe7&scoped=true"
import script from "./OnlyOfficeEditor.vue?vue&type=script&lang=js"
export * from "./OnlyOfficeEditor.vue?vue&type=script&lang=js"
import style0 from "./OnlyOfficeEditor.vue?vue&type=style&index=0&id=1680bfe7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1680bfe7",
  null
  
)

export default component.exports